module.exports = __webpack_public_path__ + "img/icon1.df44ae13.17e4391b.png";